import { CheckboxMenuItem, ControlMenuItemType, ToggleMenuItem } from './types';

export const setCheckboxValueRecursively = (
  item: ControlMenuItemType,
  value: boolean
): void => {
  if (item.type !== 'checkbox' && item.type !== 'toggle') {
    return;
  }
  item.setValue(value);
  if ('children' in item && item.children) {
    item.children.forEach((child) => setCheckboxValueRecursively(child, value));
  }
};

export const isCheckboxIndeterminate = (
  item: CheckboxMenuItem,
  children: ControlMenuItemType[]
): boolean => {
  if (item.indeterminate) {
    return item.indeterminate();
  }

  const checkableChildren = children.filter(
    (child): child is CheckboxMenuItem | ToggleMenuItem =>
      child.type === 'checkbox' || child.type === 'toggle'
  );
  if (checkableChildren.length === 0) {
    return false;
  }

  const checkedCount = checkableChildren.filter(
    (child) => child.value() ?? false
  ).length;
  return checkedCount > 0 && checkedCount < checkableChildren.length;
};
